import { BehaviorSubject, Subject } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  SidenavFooterConfig,
  SidenavHeaderConfig,
  SidenavMenuConfig,
  SidenavParamsConfig,
} from '@config/sidenav.config';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';

import { AuthService } from '@auth0/auth0-angular';
import { CompanyApiService } from '@zonar-ui/sidenav/lib/services/api/company-api.service';
import { DatadogService } from '@services/data-dog.service';
import { FeatureToggleService } from './services/feature-toggle.service';
import { GTCxMobileHelperService } from '@zonar-ui/gtcx-mobile-helper';
import { PermissionsService } from '@zonar-ui/auth';
import { SelectedCompanyService } from './services/selected-company-service/selected-company.service';
import { UserCompany } from './models/user.company.model';
import { appName } from '@environments/shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  loading = true;
  title = appName;

  selectedCompanyId$ = new BehaviorSubject<UserCompany>({
    title: '',
    value: '',
  });
  sidenavHeader = SidenavHeaderConfig;
  sidenavMenu = SidenavMenuConfig;
  sidenavFooter = SidenavFooterConfig;
  sidenavParams = SidenavParamsConfig;


  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public auth: AuthService,
    private datadogService: DatadogService,
    private featureToggleService: FeatureToggleService,
    private gtcxMobileHelperService: GTCxMobileHelperService,
    private companyService: SelectedCompanyService
  ) {
    this.auth.isAuthenticated$.pipe(
      filter((isAuthenticated) => Boolean(isAuthenticated))
    ).subscribe(() => {
      // this.datadogService.startSessionReplayRecording();
      this.featureToggleService.initialize();
    });
  }

  ngOnInit(): void {

    // if (environment.region === 'NA') {
    //   this.zuiAnalytics.addGtmToDom();
    // }

    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd && environment.region === 'NA') {
    //     const tag = { event: 'page', pageName: event.url };
    //     this.zuiAnalytics.pushTag(tag);
    //   }
    // });


    this.selectedCompanyId$.pipe(
      takeUntil(this.destroy$),
      filter(({ value }) => !!value),
      distinctUntilChanged((prev, curr) => prev.value === curr.value),
    ).subscribe(({ value }) => {
      this.gtcxMobileHelperService.setCurrentCompany(value);
      this.companyService.setCurrentCompany(value);
    });
  }

  setCurrentCompanyByFormSelection(event): void {
    this.selectedCompanyId$.next(event);
  }

  // #region Side Nav Functions
  onSideNavMobileMenuButtonToggled(event) {
    this.sidenavParams.mobileOpened = event;
  }
  // #endregion Side Nav Functions

  ngOnDestroy(): void {
    this.datadogService.stopSessionReplayRecording();
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
